import React, { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { userErrorFeedback } from "../app/utility/user-feedback-config";

//redux
import { useDispatch } from "react-redux";
import * as auth from "../app/modules/auth/redux/AuthRedux";

type FunctionType = () => Promise<AxiosResponse<any>>;

export const useFetchDataForAll = (apiCall: FunctionType) => {
  const [fetchData, setFetchData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [refetchIndex, setRefetchIndex] = useState<any>(0);

  const refetch = (lodingIndicator = false) => {
    setLoading(lodingIndicator);
    setRefetchIndex((prev: number) => prev + 1);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const getData = async () => {
      setError("");
      try {
        const response = await apiCall();
        // console.log(response);
        if (response.data?.success) {
          setFetchData(response);
        } else {
          userErrorFeedback(response.data?.message);
          setError(response.data?.message);
        }
      } catch (error: any) {
        if (error.response) {
          if (error.response.status === 401) {
            // dispatch(auth?.actions.logout());
          }
          // console.log(error);
          const message = error.response.data?.message || "Server Error";
          userErrorFeedback(message);
          setError(message);
        } else {
          const message = error?.message || "Unknown Error";
          userErrorFeedback(message);
          setError(message);
        }
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [refetchIndex]);

  return [fetchData, loading, error, refetch];
};
